import { render, staticRenderFns } from "./auction-actions-prices.vue?vue&type=template&id=3a0c4099&"
import script from "./auction-actions-prices.vue?vue&type=script&lang=js&"
export * from "./auction-actions-prices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports